// ═══ FAMILIE TAB ═════════════════════════════════════════════════════════════
import React from "react";
import { confirmDelete, asStrArr } from './helpers';
import { IconTrash } from './ui';
import { t } from './i18n';

export function FamilieTab({family,setFamily,setModal,aiSummary,onRefreshAI,onSwitchProfile,onDeleteMember,profiles=[],sharedAccess=[],onOpenShared,readOnly=false}) {
  return (
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
        <div className="sec" style={{margin:0}}>{t("Membrii familiei")}</div>
        {!readOnly&&<button className="bp" style={{fontSize:12,padding:"7px 14px"}} onClick={()=>setModal({type:"addFamily"})}>+ {t("Adaugă")}</button>}
      </div>
      {family.map(f=>(
        <div key={f.id} className="card">
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
            <div style={{flex:1}}>
              <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:4,flexWrap:"wrap"}}>
                <span style={{fontWeight:700,fontSize:16}}>{f.name}</span>
                <span className="pill" style={{background:"var(--border)",color:"var(--text-2)"}}>{t(f.relation)}</span>
                {f.shareAccess&&<span className="pill" style={{background:"var(--green-bg-soft)",color:"var(--green)",fontSize:10}}>{t("✓ Acces partajat")}</span>}
                {f.caregiver&&<span className="pill" style={{background:"var(--purple-bg-soft)",color:"var(--purple)",fontSize:10}}>{t("👩‍⚕️ Îngrijitor")}</span>}
                {f.profileId&&profiles?.find(p=>p.id===f.profileId)&&(
                  <span className="pill" style={{background:"var(--blue-bg)",color:"var(--blue)",fontSize:10,cursor:"pointer"}} onClick={()=>onSwitchProfile(f.profileId)}>{t("📋 Vezi dosar →")}</span>
                )}
                {(()=>{
                  // Dacă am acces partajat la un profil cu numele acestui membru, arată butonul
                  const sharedMatch = sharedAccess.find(acc=>acc.profile_name===f.name);
                  if(sharedMatch && onOpenShared){
                    return <span className="pill" style={{background:"var(--green-bg-soft)",color:"var(--green)",fontSize:10,cursor:"pointer"}} onClick={()=>onOpenShared(sharedMatch)}>{t("📋 Vizualizare dosar →")}</span>;
                  }
                  return null;
                })()}
              </div>
              {(f.dob||f.sex)&&<div style={{fontSize:13,color:"var(--text-3)",marginBottom:4}}>{f.dob}{f.dob&&f.sex?" · ":""}{f.sex==="M"?t("Masculin"):f.sex==="F"?t("Feminin"):""}</div>}
              {f.email&&<div style={{fontSize:12,color:"var(--text-2)",marginBottom:4}}>✉ {f.email}</div>}
              {f.conditions?.length>0&&(
                <div style={{marginTop:6}}>
                  <div className="lbl">{t("Condiții medicale")}</div>
                  <div style={{display:"flex",flexWrap:"wrap",gap:4,marginTop:4}}>
                    {f.conditions.map((c,i)=><span key={i} className="pill" style={{background:"var(--blue-bg)",color:"var(--blue-2)"}}>{c}</span>)}
                  </div>
                </div>
              )}
              {f.shareAccess&&f.email&&(
                <div style={{marginTop:8,padding:"8px 10px",background:"var(--green-bg-soft)",borderRadius:6,border:"1px solid var(--green-line)"}}>
                  <div style={{fontSize:11,color:"var(--green)"}}>✓ {t("Link de acces trimis la")} {f.email}</div>
                  <div style={{fontSize:10,color:"var(--text-4)",marginTop:2}}>{t("Acces limitat · AI poate accesa istoricul familial pentru recomandări")}</div>
                </div>
              )}
            </div>
            <div style={{display:"flex",gap:6}}>
              {!readOnly&&<button className="bg" style={{fontSize:11,padding:"4px 10px"}} onClick={()=>setModal({type:"addFamily",data:f})}>✎</button>}
              {!readOnly&&<button className="bdel" onClick={()=>confirmDelete(undefined,()=>onDeleteMember(f._dbId))}><IconTrash/></button>}
            </div>
          </div>
        </div>
      ))}
      {family.length===0&&<div className="card" style={{textAlign:"center",color:"var(--text-4)",padding:"40px 0"}}><div style={{fontSize:36,marginBottom:8}}>👨‍👩‍👧‍👦</div>{t("Niciun membru adăugat.")}</div>}
      {asStrArr(aiSummary?.familyRiskRecommendations).length>0&&(
        <div style={{marginTop:16}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
            <div className="sec" style={{margin:0,color:"var(--purple)"}}>{t("✦ Recomandări AI — risc familial")}</div>
            <button className="bai" style={{fontSize:11,padding:"4px 10px"}} onClick={onRefreshAI}>↻</button>
          </div>
          <div className="card" style={{border:"1px solid var(--purple-line)"}}>
            {asStrArr(aiSummary.familyRiskRecommendations).map((r,i,arr)=>(
              <div key={i} style={{display:"flex",gap:10,padding:"8px 0",borderBottom:i<arr.length-1?"1px solid var(--border)":"none"}}>
                <span style={{color:"var(--purple)",flexShrink:0}}>✦</span>
                <div style={{fontSize:13,lineHeight:1.6,color:"var(--purple-2)"}}>{r}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
